"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InboxRuleRow_1 = require("./InboxRuleRow");
var InboxRulesEdit_1 = require("./InboxRulesEdit");
var generateInboxRulesDiagnosticReport_1 = require("../actions/generateInboxRulesDiagnosticReport");
var getInboxRules_1 = require("../actions/getInboxRules");
var initializeInboxRulesFolders_1 = require("../actions/helpers/initializeInboxRulesFolders");
var setInboxRuleDiagnosticRequestStatus_1 = require("../actions/helpers/setInboxRuleDiagnosticRequestStatus");
var initializeInboxRuleEdit_1 = require("../actions/initializeInboxRuleEdit");
var isInboxRuleOptionEditState_1 = require("../actions/helpers/isInboxRuleOptionEditState");
var store_1 = require("../store/store");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Button_2 = require("office-ui-fabric-react/lib/Button");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_options_controls_1 = require("owa-options-controls");
var styles = require('./InboxRulesFull.scss');
var className = require('classnames/bind').bind(styles);
var InboxRulesFull = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFull, _super);
    function InboxRulesFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesFull.prototype.componentWillMount = function () {
        setInboxRuleDiagnosticRequestStatus_1.default(0 /* NotInitiated */);
        initializeInboxRulesFolders_1.default();
    };
    InboxRulesFull.prototype.componentDidMount = function () {
        getInboxRules_1.default();
    };
    InboxRulesFull.prototype.render = function () {
        return isInboxRuleOptionEditState_1.default()
            ? this.renderInboxRulesEditPage()
            : this.renderRuleList();
    };
    /**
     * Gives back the list of rows depending on the status of getting inbox rules
     * @return inbox rule list
     */
    InboxRulesFull.prototype.renderRuleList = function () {
        var getInboxRuleRequestStatus = this.props.inboxRulesListState.getInboxRuleRequestStatus;
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_inboxRules_description),
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-rules-advanced') && (React.createElement(Button_2.ActionButton, { className: styles.ruleCommandButton, onClick: function () { return initializeInboxRuleEdit_1.default(); }, text: owa_options_strings_1.default.options_inboxRules_addNewRule, iconProps: {
                    iconName: "Add" /* Add */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                } })),
            this.getInboxRulesListContent(getInboxRuleRequestStatus)));
    };
    InboxRulesFull.prototype.getInboxRulesListContent = function (getInboxRuleRequestStatus) {
        switch (getInboxRuleRequestStatus) {
            case 2 /* Complete */:
                return this.renderRuleRows();
            case 3 /* Error */:
                return this.getInboxRuleError();
            case 1 /* Pending */:
            default:
                return React.createElement(Spinner_1.Spinner, { className: styles.loadingSpinner, type: Spinner_1.SpinnerType.large });
        }
    };
    /**
     * Creates error message div on get inbox rules error
     * @return error message div
     */
    InboxRulesFull.prototype.getInboxRuleError = function () {
        return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error, isMultiline: false, actions: 
            // Localize button text VSTS: 19216
            React.createElement(Button_1.DefaultButton, { onClick: function () {
                    getInboxRules_1.default();
                } }, owa_options_strings_1.default.options_inboxRules_tryAgain) }, owa_options_strings_1.default.options_inboxRules_loadingRulesError));
    };
    /**
     * Creates the rule rows in inbox rules settings page
     * @return inbox rule rows
     */
    InboxRulesFull.prototype.renderRuleRows = function () {
        var rows = [];
        var inboxRuleCollection = this.props.inboxRulesListState.inboxRuleIds;
        if (inboxRuleCollection) {
            inboxRuleCollection.forEach(function (inboxRuleId) {
                rows.push(React.createElement(InboxRuleRow_1.default, { key: inboxRuleId, inboxRuleId: inboxRuleId }));
            });
        }
        return (React.createElement("div", { className: styles.inboxRuleRowsContainer },
            rows.length > 0 ? (rows) : (React.createElement(owa_options_controls_1.OptionDescription, { className: styles.emptyRules }, owa_options_strings_1.default.options_inboxRules_noRules)),
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-rules-advanced') && this.renderDiagnosticButton()));
    };
    InboxRulesFull.prototype.renderDiagnosticButton = function () {
        switch (this.props.inboxRulesListState.getInboxRuleDiagnosticRequestStatus) {
            case 1 /* Pending */:
                return (React.createElement("div", { className: styles.diagnosticLoadingContainer },
                    React.createElement(Spinner_1.Spinner, { className: styles.diagnosticSpinner, type: Spinner_1.SpinnerType.normal }),
                    React.createElement("span", { className: styles.diagnosticLoadingText }, owa_options_strings_1.default.options_inboxRules_generateReportPending)));
            case 3 /* Error */:
                return (React.createElement("span", { className: styles.diagnosticText }, owa_options_strings_1.default.options_inboxRules_generateReportFail));
            case 2 /* Complete */:
                return (React.createElement("span", { className: styles.diagnosticText }, owa_options_strings_1.default.options_inboxRules_generateReportSuccess));
            default:
                return (React.createElement("div", { className: styles.generateReportText },
                    React.createElement(Button_2.ActionButton, { className: styles.ruleCommandButton, onClick: function () { return generateInboxRulesDiagnosticReport_1.default(); }, text: owa_options_strings_1.default.options_inboxRules_generateReport })));
        }
    };
    InboxRulesFull.prototype.renderInboxRulesEditPage = function () {
        return React.createElement(InboxRulesEdit_1.default, null);
    };
    InboxRulesFull = tslib_1.__decorate([
        react_1.reactive({
            inboxRulesListState: function () { return store_1.default.inboxRulesListState; },
        })
    ], InboxRulesFull);
    return InboxRulesFull;
}(React.Component));
exports.default = InboxRulesFull;
//# sourceMappingURL=InboxRulesFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRulesFull.js
// module id = 5163
// module chunks = 2